export var scrollTop = function scrollTop() {
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (typeof window !== 'undefined') window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};